import React, {Component, Fragment} from 'react';
import { inject, observer } from 'mobx-react';

import {context, mesAutobind} from '@posco/posco-shared';
import {ContentLayout, Popout, Button, dialog, message} from '@posco/posco-ui-react';

import O10g015460 from '../view/O10g015460';
import O10g015461 from '../view/O10g015461';
import O10g015462 from '../view/O10g015462';
import O10g015350Container from "./O10g015350Container";
import O10g015460Repository from "../repository/O10g015460Repository";
import {action} from "mobx";



@inject('o10g015460Store')
@mesAutobind
@observer
class O10g015460Container extends Component {
  state = {
    open : false,
    openPrivacy: false,
    openSignUp: false
  };

   async componentDidMount() {
   await this.props.o10g015460Store.onFindVersion();
   await this.props.o10g015460Store.searchVersion[0].value;
   if(this.props.o10g015460Store.searchVersion[0]&& this.props.o10g015460Store.searchVersion[0].value) {
     console.log("onFindExpl::", this.props.o10g015460Store.searchVersion[0].value);
     this.props.o10g015460Store.onFindExpl(this.props.o10g015460Store.searchVersion[0].value);
     }
     this.onRetrieveAllUser030s();
   }

  // setItclearConfirmTp(itclearConfirmTp) {
  //   this.props.o10g015460Store.setItclearConfirmTp(itclearConfirmTp);
  // }

  componentWillUnmount() {

  }

  openModal() {
    this.setState({open: true});
    console.log(this.state.open);
  }


  openPrivacyModal() {
    this.setState({openPrivacy: true});
  }



  openSignUpModal() {
    this.setState({openSignUp: true});
    this.handleOpenSignUp(this.props.o10g015460Store.user030s.manPrcStexExpl2, this.props.o10g015460Store.user030s.manPrcStexExpl3)
   }

  async handleOpenSignUp(data1, data2) {
    console.log("handleOpenSignUp 1 ::::", data1);
    console.log("handleOpenSignUp 2::::", data2);
    let previewText1 = data1;
    let previewText2 = data2;
    if (document.getElementById(data1)) {
      document.getElementById(data1).innerHTML = previewText1;
    }

    if (document.getElementById(data2)) {
      document.getElementById(data2).innerHTML = previewText2;
    }
    await this.props.o10g015460Store.setUser030s({ ...this.props.o10g015460Store.user030s, manPrcStexExpl2 : previewText1 });
    await this.props.o10g015460Store.setUser030s({ ...this.props.o10g015460Store.user030s, manPrcStexExpl3 : previewText2 });

    console.log("previewText:::::", this.props.o10g015460Store.user030s.manPrcStexExpl2);
    return this.props.o10g015460Store.user030s;
  }


  /* DevEditor DOM 삽입 */
  loadJs(uri) {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.async = true;
      script.src = uri;
      document.head.appendChild(script);
      script.onload = resolve;
    });
  }

  // 에디터 로드 완료 후 실행되는 메소드
  dextEditorLoaded() {

  }

  async dext5load(data, mode) {
    console.log("`${context.path()}", `${context.path()}`)
    await this.loadJs(`${context.path()}/dext5editor/js/dext5editor.js`).then(async (a) => {
      DEXT5.config.PasteImageBase64 = "1";        // 이미지 캡쳐를 위해 사용
      DEXT5.config.UploadMethod = "base64";       // 이미지를 에디터에 넣을경우 base64 형태의 데이터로 받기
      DEXT5.config.ShowTopMenu = '0';             // Menu바 출력 X
      DEXT5.config.ShowStatusBar = '1';           // Status바 출력 X
      DEXT5.config.Width = '100%';               // 에디터 넓이 조절
      DEXT5.config.Height = '100px';              // 에디터 높이 조절
      DEXT5.config.Event.LoadedEvent = this.dextEditorLoaded; //에디터 초기 로딩 끝나고 발생하는 이벤트
      DEXT5.config.Mode = mode; //"edit": 수정(editable), "view":보기만 가능


      DEXT5.config.EditorHolder = 'manPrcStexExpl2';  // 에디터를 생성할 div의 id //개인정보수집/이용동의서
      if (document.querySelector('#manPrcStexExpl2')) {
        // await new Dext5editor('docCont');             // 에디터의 이름
        await new Dext5editor('manPrcStexExpl2');             // 에디터의 이름
      }
      DEXT5.config.EditorHolder = 'manPrcStexExpl3';  // 에디터를 생성할 div의 id //보안서약서
      if (document.querySelector('#manPrcStexExpl3')) {
        // await new Dext5editor('docCont');             // 에디터의 이름
        await new Dext5editor('manPrcStexExpl3');             // 에디터의 이름
      }
    });

    //set
    // DEXT5.setHtmlValueEx( this.state.selectedRow.stdAttCngRsn, 'stdAttCngRsn' );

    //등록: data-> null
    //수정: data -> this.state.selectedRow
    //버전: data -> target
    if(data) {
      console.log("Data:::::", data);
      // DEXT5.setHtmlValueEx( data, 'manPrcStexExpl1' );
      DEXT5.setHtmlValueEx( data.manPrcStexExpl2, 'manPrcStexExpl2' );
      DEXT5.setHtmlValueEx(  data.manPrcStexExpl3, 'manPrcStexExpl3' );
    }
  }


  onClose() {
    this.setState({open: false});
    this.setState({openPrivacy: false});
    this.setState({openSignUp: false});
  }


  /**
   * 값 변경시 setSelected
   * @param {*} props
   */



  async handleSelectChange(e, data) {
    console.log("선택 data======",data.value);
    // this.props.o10g015460Store.onChange(e, data);

    this.props.o10g015460Store.setVersion(data.value);
    console.log("버전버전", this.props.o10g015460Store.version)
  }

  /**회원가입시 개인정보처리방침**/
  //페이징
  onRetrieveAllUser030s() {
    this.props.o10g015460Store.onRetrieveAllUser030s();
  }


  /**외부사용자 아이디 찾기**/
 async onFindId(rows){
    return this.props.o10g015460Store.onFindId(rows)
      .then(action(async result => {
        if (result) {
          console.log("result==", result);
          await this.onClose();
          await this.props.o10g015460Store.clearFindId();
          await dialog.alert(message('메일이 전송되었습니다. \n 메일을 확인해주세요'));
        } else {
          await dialog.alert(message('입력하신 내용과 일치하는 정보가 없습니다. \n 이름과 이메일을 다시 입력해주세요'));

        }
      }));
  }

  /**외부사용자 비번 찾기(임시 비번 발급)**/
  async onFindPW(rows){
    return this.props.o10g015460Store.onFindPW(rows)
      .then(action(async result => {
        if (result) {
          console.log("result==", result);
          await this.onClose();
          await this.props.o10g015460Store.clearFindPW();
          await dialog.alert(message('임시 비밀번호가 입력하신 메일로 전송되었습니다. \n 메일을 확인해주세요'));
        } else {
          await dialog.alert(message('입력하신 내용과 일치하는 정보가 없습니다. \n 다시 입력해주세요'));

        }
      }));
  }

   loginWithCert(userInfo){
    console.log("loginWithCert container 들어옴");
    return this.props.o10g015460Store.loginWithCert(userInfo)
      .then(action( result => {
      console.log("userInfo result 컨테이너:::", result);
      return result;
      }));
  }

  render() {
    const {  } = this.props;
    return (
      <ContentLayout>
        {/*인증서*/}
        <O10g015460
          openModal = {this.openModal}
          openPrivacyModal = {this.openPrivacyModal}
          openSignUpModal = {this.openSignUpModal}
          loginWithCert = {this.loginWithCert}

          // region modal
          openPrivacy = {this.state.openPrivacy}
          close = {this.onClose}
          version={this.props.o10g015460Store.version}
          explan={this.props.o10g015460Store.explan}
          setExplan={this.props.o10g015460Store.setExplan}
          searchVersion={this.props.o10g015460Store.searchVersion}
          handleSelectChange={this.handleSelectChange}
          onFindExpl={this.props.o10g015460Store.onFindExpl}
          onChange={this.props.o10g015460Store.onChange}
          // endregion modal
        />
        {/*아이디/패스워드 찾기*/}
        <O10g015461
          open = {this.state.open}
          close = {this.onClose}
          findId = {this.props.o10g015460Store.findId}
          setFindId = {this.props.o10g015460Store.setFindId}
          onFindId = {this.onFindId}
          clearFindId = {this.props.o10g015460Store.clearFindId}
          findPW = {this.props.o10g015460Store.findPW}
          setFindPW = {this.props.o10g015460Store.setFindPW}
          onFindPW = {this.onFindPW}
          clearFindPW = {this.props.o10g015460Store.clearFindPW}
          tabActive = {this.props.o10g015460Store.tabActive}
          setTabActive = {this.props.o10g015460Store.setTabActive}
        />

        {/*회원가입(외부공급사 권한 신청 팝업)*/}
        <O10g015350Container
          openSignUp = {this.state.openSignUp}
          close = {this.onClose}

          user030s = {this.props.o10g015460Store.user030s}
          setUser030s = {this.props.o10g015460Store.setUser030s}



        />
      </ContentLayout>
    );
  }
}

export default O10g015460Container;
